














































import Vue from "vue";
import Layout from "@/router/layouts/main.vue";
import SearchBar from "@/components/search-bar.vue";
import VenueListItem from "@/components/venue-detail/VenueListItem.vue";
import {mapActions, mapGetters} from "vuex";
import {VenueData, VenueSubscriptionData} from '@/types';
import {fillWithMockData, WINDOW_WIDTH} from "@/utils/helpers";

export default Vue.extend({
  components: {
    Layout,
    "search-bar": SearchBar,
    "venue-list-item": VenueListItem
  },

  async created(): Promise<void> {
    await this.checkLoggedUserRolePermission({ permissionId: 4 });
  },

  async mounted(): Promise<void> {
    await this.fetchVenues({fetchRatings: true, name: ''} );
    await this.setVenuesSubscription();
    await this.setSubscriptionProducts();
    this.fetchVenuesImages();
  },

  data() {
    return {
      currentPage: 1,
      perPage: 10
    }
  },

  computed: {
    ...mapGetters("venueModule", {
      venues: "GET_VENUES"
    }),
    ...mapGetters("venueSubscriptionModule", {
      venuesSubscription: "GET_VENUES_SUBSCRIPTION",
      subscriptionProducts: "GET_ALL_SUBSCRIPTION_PRODUCTS"
    }),
    totalVenues(): number {
      return this.mixedVenuesContent.length;
    },
    venuesList(): Array<VenueData> {
      return this.mixedVenuesContent.slice((this.currentPage - 1) * this.perPage, this.currentPage * this.perPage);
    },
    mixedVenuesContent(): Array<VenueData> {
      const length: number = WINDOW_WIDTH <= 1440 ? 8 : 10;

      return fillWithMockData(this.venues, 10, length, {
        name: "Venue name",
        address1: "Address",
        mock_value: true
      })
    }
  },

  methods: {
    ...mapActions("venueModule", {
      fetchVenues: "FETCH_VENUES"
    }),
    ...mapActions("venueSubscriptionModule", {
      setVenuesSubscription: "FETCH_VENUES_SUBSCRIPTION",
      setSubscriptionProducts: "FETCH_SUBSCRIPTION_PRODUCTS"
    }),
    ...mapActions("globalModule", {
      setImage: "FETCH_ENTITY_IMAGE"
    }),
    emitVenuesImages(): void {
      this.currentPage = 1;
      this.fetchVenuesImages();
    },
    goToAddNewVenue() {
      this.$router.push("/az-create-venue");
    },
    fetchVenuesImages(): void {
      for (let i = 0; i < this.venues.length; i++) {
        const venue: VenueData = this.venues[i];

        if (!!venue.image_last_updated) {
          this.setImage({id: venue.id, imageType: "clientzone_venue", multi: true});
        }
      }
    },
    venueSubscription(venueId: number): VenueSubscriptionData {
      return this.venuesSubscription.find(s => s.venueId === venueId);
    }
  },

  watch: {
    companyId: {
      async handler(newValue: number, oldValue: number): Promise<void> {
        if (newValue != oldValue) {
          await this.fetchVenues({fetchRatings: true, name: ''});
          await this.setVenuesSubscription();
          this.fetchVenuesImages();
        }
      }
    }
  }
});
